import '../styles/amp.scss';



// WEBPACK FOOTER //
// ./react/amp.js